export default "__VITE_ASSET__Dj2nfaT2__"